import { LoadingOutlined } from "@ant-design/icons";
import { useTranslate } from "@refinedev/core";
import { Spin, SpinProps } from "antd";

export const LoadingSpinner = ({
  loading = true,
  tip,
  styles,
  ...rest
}: {
  loading?: boolean;
  styles?: React.CSSProperties;
} & SpinProps) => {
  const t = useTranslate();
  return (
    <Spin
      spinning={loading}
      fullscreen
      tip={tip ?? t(`loading`)}
      indicator={<LoadingOutlined style={{ fontSize: 100, ...styles }} />}
      data-testid="page-loading"
      {...rest} // including data-testid if necessary
    />
  );
};
